import React from "react";
import { useLang } from "../../context/lang-context";

const LandingDownload: React.FC = () => {
  const { t } = useLang();

  return (
    <section className="download-section" id="descargar">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-12 col-md-6 text-center text-md-start">
            <h2 className="download-title">
              {t("Simple, Rápido y Más Seguro", "Simple, Fast and Safer")}
            </h2>
            <p className="download-subtitle">
              {t("Descarga la App", "Download the App")}
            </p>
            <div className="download-badges">
              <a
                href="https://apps.apple.com/us/app/foo-app/id1434604093"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/img/appstore-badge.png" alt="App Store" className="store-badge" />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.fooappmx.app"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/img/google-play-badge.png" alt="Google Play" className="store-badge" />
              </a>
            </div>
          </div>
          <div className="col-8 col-md-4 text-center mt-4 mt-md-0">
            <img
              src="/img/foo_mascot.svg"
              alt="Foo Mascot"
              className="download-mascot"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingDownload;
